import { createFileRoute, notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { NOT_FOUND_HEAD_FALLBACK } from "@/lib/brandIcons";
import { blogTaxonomyHead } from "@/lib/blog/seo";
import { TaxonomyIndex } from "#/components/blog/TaxonomyIndex";

// Same edge-cache policy as the blog list: cache a 200, never a 404.
const CACHE = "public, s-maxage=60, stale-while-revalidate=86400";

const getTags = createServerFn({ method: "GET" }).handler(async () => {
  const { loadBlogTaxonomy, resolveDogfoodWorkspaceId } = await import(
    "@/lib/blog/queries"
  );
  const workspaceId = resolveDogfoodWorkspaceId();
  return workspaceId ? await loadBlogTaxonomy(workspaceId, "tags") : undefined;
});

export const Route = createFileRoute("/blog/tags/")({
  ssr: true,
  loader: async () => {
    const data = await getTags();
    if (!data) throw notFound();
    return data;
  },
  headers: ({ loaderData }) =>
    loaderData ? { "cache-control": CACHE } : { "cache-control": "no-store" },
  // notFound()-branch icon fallback + the `as never` cast it needs: see
  // `NOT_FOUND_HEAD_FALLBACK`'s docblock (#1099 / US2).
  head: ({ loaderData }) =>
    (loaderData
      ? blogTaxonomyHead(
          loaderData.blog,
          loaderData.kind,
          loaderData.canonical,
          loaderData.feedUrl,
        )
      : NOT_FOUND_HEAD_FALLBACK) as never,
  component: BlogTagsPage,
});

function BlogTagsPage() {
  const { kind, terms } = Route.useLoaderData();
  return <TaxonomyIndex kind={kind} terms={terms} />;
}
